<template>
  <div
    v-if="step > 0"
    class="mx-auto">
    <overlay v-if="loading" />
    <div class="pt-4 sm:pt-8 pb-8 flex flex-col mx-auto">
      <a
        href="#"
        class="mb-4 flex sm:hidden"
        @click.prevent="goBack">
        <div class="flex items-center">
          <svg-icon name="leftarrow-small-thin" />
        </div>
        <span class="underline ml-3 typeset-7">
          {{ t("preferences-questionnaire.back") }}
        </span>
      </a>
      <p
        v-if="step < 4"
        class="typeset-4 mb-4 text-ink-4 sm:text-center">
        {{ t("preferences-questionnaire.step", { step, amount: 3 }) }}
      </p>
      <router-view key="view" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import Overlay from "@/app/javascript/components/shared/Overlay.vue";
import SvgIcon from "@/app/javascript/components/shared/SvgIcon.vue";

export default {
  name: "PreferencesQuestionnaire",
  components: {
    Overlay,
    SvgIcon
  },
  props: {
    landingNode: {
      type: HTMLDivElement,
      required: true
    },
    questionnaireNode: {
      type: HTMLDivElement,
      required: true
    }
  },
  computed: {
    ...mapState({
      loading: state => state.loading,
      step: state => state.step,
      results: state => state.results
    })
  },
  watch: {
    $route(to) {
      if (!to.name || to.name === "home") {
        this.setStep(0);
        this.landingNode.classList.remove("hidden");
        this.questionnaireNode.classList.add("hidden");
        analytics.track("Viewed Preferences Questionnaire", {
          step: "Opening Page",
          number: 1
        });
      } else if (to.name === "one") {
        this.setStep(1);
        this.landingNode.classList.add("hidden");
        this.questionnaireNode.classList.remove("hidden");
        analytics.track("Viewed Preferences Questionnaire", {
          step: "Cover Type",
          number: 2
        });
      } else if (to.name === "two") {
        this.setStep(2);
        analytics.track("Viewed Preferences Questionnaire", {
          step: "Colour",
          number: 3
        });
      } else if (to.name === "three") {
        this.setStep(3);
        analytics.track("Viewed Preferences Questionnaire", {
          step: "Style",
          number: 4
        });
      } else if (to.name === "four") {
        this.setStep(4);
        analytics.track("Viewed Preferences Questionnaire", {
          step: "Results",
          number: 5
        });
      }
    },
    results() {
      // run this when new results are retrieved
      if (this.$route.path !== "/picks-for-you/your-results") {
        this.$router.push("/picks-for-you/your-results");
      }
    }
  },
  methods: {
    ...mapMutations(["setStep"]),
    goBack() {
      this.$router.back();
    }
  }
};
</script>
